import React, { useState } from 'react';
import Button from '../common/Button';
import Input from '../common/Input';

const WalletSetup = ({ onWalletSetup, loading }) => {
  const [formData, setFormData] = useState({
    name: '',
    balance: '',
  });
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Wallet name is required';
    }

    if (formData.balance && isNaN(parseFloat(formData.balance))) {
      newErrors.balance = 'Balance must be a valid number';
    }

    if (formData.balance && parseFloat(formData.balance) < 0) {
      newErrors.balance = 'Balance cannot be negative';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const walletData = {
      name: formData.name.trim(),
      balance: formData.balance ? parseFloat(formData.balance) : 0,
    };

    onWalletSetup(walletData);
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 rounded-lg shadow-lg">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
        Setup Your Wallet
      </h2>

      <form onSubmit={handleSubmit}>
        <Input
          label="Wallet Name"
          name="name"
          type="text"
          value={formData.name}
          onChange={handleChange}
          placeholder="Enter wallet name"
          required
          error={errors.name}
        />

        <Input
          label="Initial Balance (Optional)"
          name="balance"
          type="number"
          step="0.0001"
          min="0"
          value={formData.balance}
          onChange={handleChange}
          placeholder="0.0000"
          error={errors.balance}
        />

        <Button
          type="submit"
          variant="primary"
          loading={loading}
          className="w-full"
        >
          Create Wallet
        </Button>
      </form>
    </div>
  );
};

export default WalletSetup;
